import {mapGetters} from 'vuex';

export default {
    name: 'agentBanner',
    inject: ['$eventBus'],
    props: {
        hotleadType: {
            type: String,
            default: 'PopupHotleadInAgentProfilePage_seller'
        }
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        agents(){
            return [
                {
                    firstName: 'Ronnie',
                    lastName: 'Mangulabnan',
                    fullName: 'Ronnie M.',
                    image: this.glb.cdnUrl + 'vimages/agents/ronnie.jpg'
                },
                {
                    firstName: 'Jeffrey',
                    lastName: 'Hess',
                    fullName: 'Jeffrey H.',
                    image: this.glb.cdnUrl + 'vimages/agents/jeffrey.jpg'
                },
                {
                    firstName: 'Sharon',
                    lastName: 'Juarez',
                    fullName: 'Sharon J.',
                    image: this.glb.cdnUrl + 'vimages/agents/sharon.jpg'
                }
            ];
        }
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadSup: 'GET STARTED',
                    hotleadTitle: 'Connect with an agent',
                    hotleadType: this.hotleadType,
                    buttonText: 'Connect Now',
                    showGeo: true,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                },
            });
        }
    }
};